<template>
  <v-row justify="center">
    <v-dialog
      v-model="curVisible"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>选择账户</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="min-height: 50px;margin: 0;padding: 0;">
          <div
            v-if="loading"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            正在加载...
          </div>
          <div
            v-else-if="userList && userList.length === 0"
            style="text-align: center;
            height: 100px;
            line-height: 100px;">
            暂无账户
          </div>
          <v-list v-else style="padding: 0;">
            <v-list-item-group
              v-model="model"
              mandatory
              color="indigo"
              active-class="border"
            >
            <template v-for="(item, i) in userList">
              <v-divider v-if="i !== 0" :key="`divider-${i}`"></v-divider>
              <v-list-item
                :key="`item-${i}`"
                @click="changeUser(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-account-group</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.label"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="model === i" color="success">mdi-check</v-icon>
                  <span v-else style="color: #9e9e9e">切换</span>
                </v-list-item-action>
              </v-list-item>
            </template>

            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
        if (!val) {
          that.$emit('closed')
        }
      }
    }
  },
  data: () => ({
    model: 0,
    userList: [],
    loading: true,
    userCode: ''
  }),
  mounted() {
    var that = this
    that.initData()
  },
  methods: {
    async initData() {
      var that = this
      await that.$AppHelper.pullUserCustomData(function(data) {
        var cpy = data.staff_info;
        if (cpy && cpy.USER_CODE) {
          that.userCode = cpy.USER_CODE;
        }
      });
      await that.getUserStaffList();
      that.loading = false
    },
    async getUserStaffList() {
      var that = this
      await that.$api.bz.getUserStaffList().then(res => {
        if (!res.success) {
          console.log('获取用户列表失败', res);
          return;
        }
        if (that.loading) {
          that.loading = false
        }
        var data = res.data
        if (data.length === 0) {
          return
        }
        that.userList = []
        for (let index = 0; index < data.length; index++) {
          var item = data[index]
          if (item.USER_CODE === that.userCode) {
            that.model = index
          }
          that.userList.push({ label: item.USER_NAME, value: item.USER_CODE })
        }
      })
    },
    async changeUser(item) {
      var that = this
      if (that.userCode === item.value) {
        that.curVisible = false
        return
      }
      var res = await that.$api.bz.toggleUser({ code: item.value })
      // console.log('toggleUser.res', res);
      if (!res.success) {
        that.$toast.warning('切换失败');
        return;
      }
      // that.$toast.success('切换成功');
      await that.$AppHelper.pullUserCustomData();
      await that.$AppHelper.pullNewUserToken();
      that.userCode = item.value;
      that.userToggled(item.value)
    },
    userToggled(code) {
      var that = this
      that.curVisible = false
      that.$emit('user-toggled', code)
    }
  }
}
</script>
<style scoped>
/* .border {
  border: 2px dashed orange;
} */
</style>
